import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { JsonPipe } from '@angular/common'
import { UserService } from '../../../core/services/user/user.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatDivider } from '@angular/material/divider'

@Component({
  selector: 'change-password',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    JsonPipe,
    MatFormFieldModule,
    MatDivider,
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  providers: [TariffTypeService],
  standalone: true,
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.userService.changePassword(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      senhaAntiga: this.form.controls['password'].value,
      senhaNova: this.form.controls['newPassword'].value,
    }
  }

  validForm() {
    if (
      this.form.valid &&
      this.form.controls['newPassword'].value ==
        this.form.controls['verifyNewPassword'].value
    ) {
      return true
    } else {
      return false
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      password: [``, [Validators.required, Validators.minLength(6)]],
      newPassword: [``, [Validators.required, Validators.minLength(6)]],
      verifyNewPassword: [``, [Validators.required, Validators.minLength(6)]],
    })
  }
}
